import { render } from "./App.vue?vue&type=template&id=45e8a211"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=45e8a211&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/puchtrade-project/puchtrade/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__